import z from 'zod'

import { MAX_MYWAVE_FREQUENCY, MIN_MYWAVE_FREQUENCY } from './constants'

export const myWaveSchema = z.object({
  trackFrequency: z
    .number()
    .min(MIN_MYWAVE_FREQUENCY, `Минимум ${MIN_MYWAVE_FREQUENCY} трек`)
    .max(MAX_MYWAVE_FREQUENCY, `Максимум ${MAX_MYWAVE_FREQUENCY} треков`),
  podcastFrequency: z
    .number()
    .min(MIN_MYWAVE_FREQUENCY, `Минимум ${MIN_MYWAVE_FREQUENCY} подкаст`)
    .max(MAX_MYWAVE_FREQUENCY, `Максимум ${MAX_MYWAVE_FREQUENCY} подкастов`),
})

export type MyWaveFormModel = z.infer<typeof myWaveSchema>
